import { Component } from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-save-recalc-confirm-dialog',
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatIcon,
    MatIconButton,
    TranslatePipe,
  ],
  templateUrl: "./save-recalc-confirm-dialog.component.html",
  styleUrls: ['./save-recalc-confirm-dialog.component.scss']
})
export class SaveRecalcConfirmDialogComponent {
  constructor(private dialogRef: MatDialogRef<SaveRecalcConfirmDialogComponent>) {}
  close(result: boolean): void {
    this.dialogRef.close(result);
  }
}
